module.exports = __webpack_public_path__ + "static/media/favicon.fb8c3702.ico";